function IconFile({ ...rest }) {
  return (
    <>
      <svg viewBox="0 0 48 48" fill="currentColor" {...rest}>
        <path d="M20.2,8.8l-8.5,8.5c-0.1,0.1,0,0.3,0.1,0.3h7.9c0.4,0,0.8-0.3,0.8-0.8V8.9c0-0.1-0.1-0.2-0.2-0.2 C20.3,8.7,20.3,8.7,20.2,8.8L20.2,8.8z" />
        <path d="M35.4,8.6H23c0,0.1,0,0.2,0,0.3v7.9c0,1.8-1.5,3.3-3.3,3.3h-7.9c-0.1,0-0.2,0-0.3,0v18.3 c0,1.1,0.9,2,2,2h21.9c1.1,0,2-0.9,2-2V10.6C37.4,9.5,36.5,8.6,35.4,8.6L35.4,8.6z" />
      </svg>
    </>
  );
}

export default IconFile;
